import type { EInvoice } from '@/lib/api/einvoice-api'
import { m } from '@/lib/paraglide/messages'

export function getEInvoiceFailureMessage(
    invoice: Pick<EInvoice, 'error_message'>,
) {
    switch (invoice.error_message) {
        case 'DRAFT_TOTAL_DRIFT':
            return m.einvoice_error_draft_total_drift()
        case 'TEMPLATE_MISMATCH':
            return m.einvoice_error_template_mismatch()
        case 'AUTH_FAILED':
            return m.einvoice_error_auth_failed()
        default:
            return invoice.error_message
                ? m.einvoice_error_unknown()
                : undefined
    }
}
